<ng-container *ngIf="reportId && widget.widgetLockInfo && (!widget.widgetLockInfo.locked || (widget.widgetLockInfo.locked && !widget.widgetLockInfo.lockedByCurrentUser))">
  <div class="widget-locker-overlay-vertical">&nbsp;</div>
  <div class="widget-locker-overlay-horizontal">&nbsp;</div>
</ng-container>
<div class="widget-box box-content widget-rows-{{widget.sizeY}} widget-cols-{{widget.sizeX}}">
  <div class="box-header-menu" *ngIf="(appWidgetHeaderMode$ | async)">
    <kendo-menu (select)="onSelect($event)" size="large" [vertical]="true" cssClass="box-menu">
      <kendo-menu-item text="open">
        <ng-template kendoMenuItemTemplate let-item="item">
          <span class="k-icon k-i-more-vertical"></span>
        </ng-template>
        <kendo-menu-item text="activate" cssClass="k-sub-menu-item-widget-box">
          <!--Activate widget-->
          <ng-template kendoMenuItemTemplate let-item="item">
            <span class="k-icon k-i-checkmark activateButton" title="{{ 'activateWidget' | translate  | uppercase }}"></span>
          </ng-template>
        </kendo-menu-item>

        <!--Lock /unlock widget-->
        <kendo-menu-item text="lock" *ngIf="!hideCheckoutNotification" cssClass="k-sub-menu-item-widget-box">
          <ng-template kendoMenuItemTemplate let-item="item">
            <span *ngIf="widget.widgetLockInfo.locked && widget.widgetLockInfo.lockedByCurrentUser" class="k-icon k-i-track-changes-enable widgetLockedByCurrentUser lockButton" title="{{ 'widgetLock.unlockWidget' | translate  | uppercase }}"></span>
            <span *ngIf="widget.widgetLockInfo.locked && !widget.widgetLockInfo.lockedByCurrentUser" class="k-icon k-i-lock lockWidgetNotPossible lockButton" title="{{ 'widgetLock.lockWidget' | translate  | uppercase }}"></span>
            <span *ngIf="!widget.widgetLockInfo.locked" class="k-icon k-i-track-changes-enable lockButton" title="{{ 'widgetLock.lockWidget' | translate  | uppercase }}"></span>
          </ng-template>
        </kendo-menu-item>

        <!--Comment widget-->
        <kendo-menu-item text="comment" *ngIf="showCommentBtn" cssClass="k-sub-menu-item-widget-box">
          <ng-template kendoMenuItemTemplate let-item="item">
            <span class="k-icon k-i-comment commentButton" title="{{ 'commentWidget' | translate  | uppercase }}" [class.red-comment-button]="redButton"></span>
          </ng-template>
        </kendo-menu-item>

        <!--Toggle Kendo editor-->
        <kendo-menu-item text="editor" *ngIf="hasKendoEditor" cssClass="k-sub-menu-item-widget-box">
          <ng-template kendoMenuItemTemplate let-item="item">
            <span class="k-icon k-i-edit-tools kendoEditorToggleToolbar" title="{{ 'kendoEditorToggleToolbar' | translate  | uppercase }}" [class.toolbar-enabled]="widget.widgetSettings.showKendoEditor"></span>
          </ng-template>
        </kendo-menu-item>

        <!--Toggle Slideout-->
        <kendo-menu-item text="slideout" *ngIf="hasSlideOut" cssClass="k-sub-menu-item-widget-box">
          <ng-template kendoMenuItemTemplate let-item="item">
            <span class="k-icon k-i-table-properties" title="{{ 'toggleSlideOut' | translate  | uppercase }}" [class.toolbar-enabled]="widget.widgetSettings.showSlideOut"></span>
          </ng-template>
        </kendo-menu-item>

        <!--Delete widget-->
        <kendo-menu-item text="delete" *ngIf="showDeleteBtn" cssClass="k-sub-menu-item-widget-box">
          <ng-template kendoMenuItemTemplate let-item="item">
            <span class="k-icon k-i-trash deleteButton" title="{{ 'deleteWidget' | translate  | uppercase }}"></span>
          </ng-template>
        </kendo-menu-item>
      </kendo-menu-item>
    </kendo-menu>
    <div *ngIf="buttonInfobar && ((parallelWorking && !hideCheckoutNotification) || (redButton && !hideCheckoutNotification))" class="k-animation-container" style="left: 17px; top: 0px; width: 43.2px; max-height: 113.99px; overflow: visible; display: block; position: absolute;">
      <ul class="k-group k-menu-group k-popup k-reset k-state-border-left" role="menu" style="line-height: normal; overflow: auto; font-size: 14px; font-style: normal; font-weight: 400; display: block; position: absolute; max-height: 1265px; font-stretch: normal; transform: translateX(0px); padding: .28em .9em .38em .9em !important;" data-role="popup">
        <li class="k-item k-state-default k-first" role="menuitem">
          <span class="k-link">
            <span class="k-icon k-i-track-changes-enable widgetLockedByCurrentUser lockButton" title="{{ 'widgetLock.unlockWidget' | translate  | uppercase }}" *ngIf="widget.widgetLockInfo.locked && widget.widgetLockInfo.lockedByCurrentUser" (click)="tryLockWidget()"></span>
            <span class="k-icon k-i-lock lockWidgetNotPossible lockButton" title="{{ 'widgetLock.lockWidget' | translate  | uppercase }}" *ngIf="widget.widgetLockInfo.locked && !widget.widgetLockInfo.lockedByCurrentUser" (click)="tryLockWidget()"></span>
            <span class="k-icon k-i-track-changes-enable lockButton" title="{{ 'widgetLock.lockWidget' | translate  | uppercase }}" *ngIf="!widget.widgetLockInfo.locked" (click)="tryLockWidget()"></span>
          </span>
        </li>
        <li class="k-item k-state-default k-first" role="menuitem" *ngIf="redButton">
          <span class="k-link">
            <span class="k-icon k-i-comment commentButton" title="{{ 'commentWidget' | translate  | uppercase }}" (ngClass)="{ 'red-comment-button': redButton}" (click)="commentWidget()"></span>
          </span>
        </li>
      </ul>
    </div>
  </div>
  <ng-template widgetHost></ng-template>
</div>

